mutation PutMerchApp(
  $appKey: String!
  $label: String
  $distribution: String!
  $ownerEmail: String!
  $installLinkUrl: String
) {
  app: StreamToolsPutMerchApp(
    appKey: $appKey
    label: $label
    distribution: $distribution
    ownerEmail: $ownerEmail
    installLinkUrl: $installLinkUrl
  ) {
    appKey
    label
    distribution
    ownerAccountId
    ownerEmail
    installLinkUrl
    installLinkIssuedAt
    installLinkExpiresAt
    shopCount
    createdAt
  }
}
